import React, { PureComponent } from 'react';
import { Switch, Route } from 'react-router-dom';
import noop from 'lodash/fp/noop';

import { firebase } from '../../utils/firebase';
import FirebaseAuth from '../widgets/FirebaseAuth';

class LogoutPage extends PureComponent {
    componentWillMount() {
        firebase.auth().signOut();
    }

    render() {
        return (
            <div>Signing out...</div>
        );
    }
}

function LoginPage() {
    return (
        <div className="Login-container">
            <FirebaseAuth onSignIn={noop}>
                Please Wait...
            </FirebaseAuth>
        </div>
    );
}

function AuthPage(props) {
    const { match } = props;

    return (
        <Switch>
            <Route path={`${match.url}/login`} component={LoginPage} />
            <Route path={`${match.url}/logout`} component={LogoutPage} />
        </Switch>
    );
}

export default AuthPage;



// WEBPACK FOOTER //
// ./src/components/pages/AuthPage.js